import firebase from 'firebase/app'
import {db} from '@/firebase'
import { store } from '@/store'
import EventEmitter from 'events'

// Extend EventEmitter so user of DoctorRepository can react to our own defined events. (ex: doctorRepository.on('added'))
class DoctorOfficeRepository extends EventEmitter {
    // Check if a Doctor exists
    load (userId, onSuccess, onError) {
        db.collection('offices')
            .where('doctorId', '==', userId)
            .get()
            .then((querySnapshot) => {
                let offices = {}

                querySnapshot.forEach((doc) => {
                    offices[doc.id] = doc.data()
                });

                onSuccess(offices)
            })
            .catch((error) => {
                onError(error)
            })
    }

    // Create an Office
    create (doctor, {name = '', streetName = '', streetNumber = '', zipCode = '', locality = '', phone = '', countryId = '', location = null, isEmergencyEmailAlertEnabled = false}, onComplete, onError) {

        var newDoc = db.collection('offices').doc()

        let office = {
            id: newDoc.id,
            name,
            streetName,
            streetNumber,
            zipCode,
            locality,
            phone,
            countryId,
            location,
            isEmergencyEmailAlertEnabled,
            doctorId: doctor.id,
            doctorFirstName: doctor.firstName,
            doctorLastName: doctor.lastName,
            doctorType: doctor.type,
            doctorAvatar: doctor.avatar,
            isDoctorRegulated: doctor.isRegulated
        }

        if (location == null) {
            office.location = new firebase.firestore.GeoPoint(process.env.DEFAULT_LAT, process.DEFAULT_LNG)
        }

        db.collection('offices').doc(office.id)
            .set(office)
            .then(() => {
                this.load(doctor.id, (offices) => {
                    store.dispatch('setOffices', offices)

                    onComplete(office.id)
                })
            })
            .catch(onError);
    }

    // Update an Office
    update (doctorId, officeId, data, onComplete, onError) {

        if (data.location == null) {
            data.location = new firebase.firestore.GeoPoint(process.env.DEFAULT_LAT, process.DEFAULT_LNG)
        }

        db.collection('offices')
            .doc(officeId)
            .update(data)
            .then(() => {
                this.load(doctorId, (offices) => {
                    store.dispatch('setOffices', offices)

                    onComplete()
                })
            })
            .catch(onError);

    }

    // Remove a Doctor
    remove ({key}, onComplete) {
        db.collection('offices').doc(key).remove(onComplete)
    }

    onChanged (type, doc) {
        if (type == 'modified' || type == 'added') {
            store.dispatch('setOffice', doc.data())
        }

        if (type == 'removed') {
            store.dispatch('removeOffice', doc.id)
        }

        this.emit(type, doc.id, doc.exists ? doc.data() : null)
    }
}

export default new DoctorOfficeRepository()


// WEBPACK FOOTER //
// ./src/data/DoctorOfficeRepository.js